/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "1",
    image:
      "https://lp2.hm.com/hmgoepprod?set=quality%5B79%5D%2Csource%5B%2Fc4%2F58%2Fc4583e5b8e7a670e78570ab67bba3a0d6dfc8d68.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5B%5D%2Ctype%5BLOOKBOOK%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url[file:/product/main]",
    category: "men",
    size: "s",
    title: "Relaxed Fit Sweatshirt",
    price: "1499",
    rating: "3.2",
    trending: false,
    delivery_time: "8",
    reviews: "2.2",
    in_stock: true,
  },
  {
    _id: "2",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/3b/85/3b85e918578a1d0d4d088079d2fde073c84b2307.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "m",
    category: "Women",
    title: "Cable-knit Skirt",
    price: "899",
    rating: "3.9",
    trending: true,
    delivery_time: "5",
    reviews: "2.7",
    in_stock: false,
  },
  {
    _id: "3",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/60/aa/60aa3430d85015784e00159df4f83655463caf8e.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "l",
    category: "kids",
    title: "2-piece embroidery-detail set",
    price: "999",
    rating: "4.5",
    trending: false,
    delivery_time: "7",
    reviews: "2.8",
    in_stock: true,
  },
  {
    _id: "4",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/b9/c3/b9c35ad5296be401e4e21059598f1348545c839f.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    category: "Women",
    size: "l",
    title: "Oversized Turtleneck Sweater",
    price: "1199",
    rating: "4.9",
    trending: false,
    delivery_time: "9",
    reviews: "2.9",
    in_stock: true,
  },
  {
    _id: "5",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/78/cb/78cbd0b4d9aca0856861d0eb5adafab62795815f.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "l",
    category: "Women",
    title: "Cut-out Jersey Dress",
    price: "1499",
    rating: "1.8",
    trending: true,
    delivery_time: "7",
    reviews: "2.9",
    in_stock: true,
  },

  {
    _id: "6",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/ad/75/ad75f7a11a9fa4086b99f7f3138715e66a3a7409.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "l",
    category: "Women",
    title: "Short Twill Skirt",
    price: "399",
    rating: "4.8",
    trending: true,
    delivery_time: "8",
    reviews: "4.9",
    in_stock: true,
  },
  {
    _id: "7",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/5e/a5/5ea51f955f90dd40b64c205c30e217181699816c.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main",
    size: "s",
    category: "Women",
    title: "Hooded Sweatshirt Dress",
    price: "999",
    rating: "2.5",
    trending: false,
    delivery_time: "7",
    reviews: "2.8",
    in_stock: true,
  },
  {
    _id: "8",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/26/10/2610647bd33a73b282531dbda3fda931591e3c2a.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "m",
    category: "Women",
    title: "Lightweight running shorts",
    price: "499",
    rating: "2.8",
    trending: true,
    delivery_time: "3",
    reviews: "4.3",
    in_stock: true,
  },
  {
    _id: "9",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/d7/a7/d7a7789bff38d13d7799ad317d176bbba5e975e7.jpg],origin[dam],category[],type[LOOKBOOK],res[y],hmver[1]&call=url[file:/product/main]",
    size: "l",
    category: "Women",
    title: "Belted Shirt Dress",
    price: "1299",
    rating: "2.8",
    trending: true,
    delivery_time: "5",
    reviews: "3.3",
    in_stock: false,
  },
  {
    _id: "10",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/8a/9c/8a9cea863b2503095573240b56ddb140c1011ff3.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xl",
    category: "Women",
    title: "Platform Chelsea-style Boots",
    price: "1199",
    rating: "3.8",
    trending: true,
    delivery_time: "7",
    reviews: "3.4",
    in_stock: true,
  },
  {
    _id: "11",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/27/16/27168c044485b19b54519014202acf100e55d196.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xl",
    category: "Women",
    title: "Wide High Jeans",
    price: "1599",
    rating: "4.8",
    trending: true,
    delivery_time: "2",
    reviews: "4.4",
    in_stock: true,
  },
  {
    _id: "12",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/79/4a/794afddb032b13021106ec59bb7000e520e1f5a4.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xxl",
    category: "Women",
    title: "Wide twill trousers",
    price: "599",
    rating: "4.8",
    trending: true,
    delivery_time: "2",
    reviews: "4.4",
    in_stock: true,
  },
  {
    _id: "13",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/04/fa/04fa110f9b22492afe5bb255fa2d9192eaa524b1.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    category: "Women",
    size: "l",
    title: "Tailored-look Belted Dress",
    price: "1499",
    rating: "1.2",
    trending: false,
    delivery_time: "8",
    reviews: "2.2",
    in_stock: true,
  },
  {
    _id: "14",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/6b/a5/6ba5180a26cb095544b29ba6ffadb53bb670be1e.jpg],origin[dam],category[ladies_tops_vests],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    size: "xxl",
    category: "Women",
    title: "2-pack Cotton Tank Tops",
    price: "1199",
    rating: "3.1",
    trending: true,
    delivery_time: "3",
    reviews: "2.6",
    in_stock: true,
  },
  {
    _id: "15",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/49/56/49560dfa45732ed844e8e4742afdca248ee60f9f.jpg],origin[dam],category[men_tshirtstanks_shortsleeve],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xl",
    category: "men",
    title: "Relaxed Fit T-shirt",
    price: "1199",
    rating: "4.8",
    trending: true,
    delivery_time: "7",
    reviews: "3.4",
    in_stock: true,
  },

  {
    _id: "16",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/5a/1a/5a1abd8d6279e682848cbe5720673f36e7930610.jpg],origin[dam],category[],type[LOOKBOOK],res[y],hmver[1]&call=url[file:/product/main]",
    size: "xl",
    category: "men",
    title: "Backpack",
    price: "999",
    rating: "4.5",
    trending: false,
    delivery_time: "7",
    reviews: "2.8",
    in_stock: true,
  },

  {
    _id: "17",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/16/df/16dfa90713a5a5feafbf865f3ec5ff32cf844841.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "m",
    category: "men",
    title: "Regular Fit sweatshirt shorts",
    price: "399",
    rating: "2.8",
    trending: true,
    delivery_time: "8",
    reviews: "4.9",
    in_stock: true,
  },
  {
    _id: "18",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/40/97/40977e516f8b91079318825df532cc1964566779.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "l",
    category: "men",
    title: "Relaxed Fit Hoodie",
    price: "499",
    rating: "2.8",
    trending: true,
    delivery_time: "3",
    reviews: "4.3",
    in_stock: true,
  },
  {
    _id: "19",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/57/ab/57ab9bbb793a799acfab98d6b4cb717f0cc27b18.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xxl",
    category: "men",
    title: "Relaxed Fit Linen-blend shirt",
    price: "1299",
    rating: "3.8",
    trending: true,
    delivery_time: "5",
    reviews: "3.3",
    in_stock: false,
  },

  {
    _id: "20",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/b7/6a/b76ac8c60dae22679b69f9f94f1bb94217bb820b.jpg],origin[dam],category[men_tshirtstanks_shortsleeve],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "l",
    category: "men",
    title: "Regular Fit Round-neck T-shirt",
    price: "1599",
    rating: "1.8",
    trending: true,
    delivery_time: "2",
    reviews: "4.4",
    in_stock: true,
  },
  {
    _id: "21",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/a9/eb/a9ebb33395b09b39b122e1802f8e085cd5bf2ed2.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "m",
    category: "men",
    title: "Regular Fit Joggers",
    price: "899",
    rating: "1.9",
    trending: true,
    delivery_time: "5",
    reviews: "2.7",
    in_stock: false,
  },
  {
    _id: "22",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/70/61/706176203406264a91657691aff63c1e65ba808d.jpg],origin[dam],category[men_shirts_shortsleeved],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    size: "m",
    category: "men",
    title: "Patterned resort shirt",
    price: "599",
    rating: "2.8",
    trending: true,
    delivery_time: "2",
    reviews: "4.4",
    in_stock: true,
  },
  {
    _id: "23",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/b2/5d/b25df154049847b8cc930f44aa5a0e9175cf4a81.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
    category: "men",
    size: "xxl",
    title: "Cargo joggers",
    price: "1199",
    rating: "2.9",
    trending: false,
    delivery_time: "9",
    reviews: "2.9",
    in_stock: true,
  },

  {
    _id: "24",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/cc/78/cc783b01c22bb9a1f73293e2ac74c6d4c2727298.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    size: "xl",
    category: "men",
    title: "Relaxed Fit Sweatshirt",
    price: "1499",
    rating: "1.8",
    trending: true,
    delivery_time: "7",
    reviews: "2.9",
    in_stock: true,
  },
  {
    _id: "25",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/da/d8/dad83bb0763845cc86e8ff7e22bde233f12a7233.jpg],origin[dam],category[men_shoes_sandals_espandrillos],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "s",
    category: "men",
    title: "Leather mules",
    price: "1199",
    rating: "3.1",
    trending: true,
    delivery_time: "3",
    reviews: "2.6",
    in_stock: true,
  },

  {
    _id: "26",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/32/27/322739698071375d0000cb67494ebfa22de359a2.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "s",
    category: "kids",
    title: "2-piece top and shorts set",
    price: "1199",
    rating: "3.1",
    trending: true,
    delivery_time: "3",
    reviews: "2.6",
    in_stock: true,
  },
  {
    _id: "27",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/76/44/76445217d4a50e14dde63bd3feb5fa8f913c9b9b.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "s",
    category: "kids",
    title: "2-piece terry set",
    price: "899",
    rating: "1.9",
    trending: true,
    delivery_time: "5",
    reviews: "2.7",
    in_stock: false,
  },
  {
    _id: "28",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/19/a6/19a6c3a63ee1de66d7a61a31411c01c56b4b4484.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xxl",
    category: "kids",
    title: "2-piece printed set",
    price: "1199",
    rating: "3.8",
    trending: true,
    delivery_time: "7",
    reviews: "3.4",
    in_stock: true,
  },
  {
    _id: "29",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/4d/59/4d59545f4ea37c45b5a59e22d9b82518dd1f2bb0.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xl",
    category: "kids",
    title: "5-pack jersey shorts",
    price: "1599",
    rating: "1.8",
    trending: true,
    delivery_time: "2",
    reviews: "4.4",
    in_stock: true,
  },
  {
    _id: "30",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/ac/d3/acd350fccf73076117c52c3ccfa717a759ecc7c2.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[2]&call=url[file:/product/main]",
    size: "xl",
    category: "kids",
    title: "2-piece set",
    price: "599",
    rating: "4.8",
    trending: true,
    delivery_time: "2",
    reviews: "4.4",
    in_stock: true,
  },
  {
    _id: "31",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/a8/d4/a8d4ea7fd0522cdd7dff9adf2df2ae79b7a77159.jpg],origin[dam],category[kids_baby_girl_clothing_tops_tshirts],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    category: "kids",
    size: "m",
    title: "Printed T-shirt",
    price: "1199",
    rating: "2.9",
    trending: false,
    delivery_time: "9",
    reviews: "2.9",
    in_stock: true,
  },
  {
    _id: "32",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/f9/8a/f98abcbbc3969be32c2acec915a873835c198813.jpg],origin[dam],category[kids_girls_accessories_hairaccessories],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    category: "kids",
    size: "m",
    title: "10-pack hair clips",
    price: "1499",
    rating: "2.2",
    trending: false,
    delivery_time: "8",
    reviews: "2.2",
    in_stock: true,
  },

  {
    _id: "33",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/c4/98/c49846bd8439995ddd18c88f6453026dfa1f6e11.jpg],origin[dam],category[kids_boys_clothing_nightwear_pyjamas],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    size: "m",
    category: "kids",
    title: "Pyjama T-shirt and shorts",
    price: "1499",
    rating: "1.8",
    trending: true,
    delivery_time: "7",
    reviews: "2.9",
    in_stock: true,
  },
  {
    _id: "34",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/c9/e0/c9e064c94396c8f4e6754ecce6999e49229ca1ae.jpg],origin[dam],category[kids_baby_boy_setsoutfits],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    size: "xxl",
    category: "kids",
    title: "6-piece jersey set",
    price: "399",
    rating: "2.8",
    trending: true,
    delivery_time: "8",
    reviews: "4.9",
    in_stock: true,
  },
  {
    _id: "35",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/a5/10/a510cfd3f54a6ef6f08d7b9b4338e82d2567dc03.jpg],origin[dam],category[kids_baby_girl_clothing_bodysuits],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/main]",
    size: "xl",
    category: "kids",
    title: "3-pack short-sleeved bodysuits",
    price: "499",
    rating: "2.8",
    trending: true,
    delivery_time: "3",
    reviews: "4.3",
    in_stock: true,
  },
  {
    _id: "36",
    image:
      "https://lp2.hm.com/hmgoepprod?set=source[/38/68/386883e16c11d2434906423422627db7ac344b3c.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/main]",
    size: "xl",
    category: "kids",
    title: "Cut-out dress",
    price: "1299",
    rating: "2.8",
    trending: true,
    delivery_time: "5",
    reviews: "3.3",
    in_stock: false,
  },
];
